// MachineServiceClient — the game's handle to the local hardware host.
// ONLINE: a no-op stub (connect() resolves false; credit/print/read throw).
// KIOSK: replaced/injected by the Machine Service host with a real client that
// bridges to device drivers and pushes PLATFORM_EVENTS onto the bus.
// See ../../CONTRACTS.md §2 and ../../machine-service/README.md.

export class MachineServiceClient {
  constructor({ bus, logger } = {}) {
    this._bus = bus || null;
    this._logger = logger || null;
    this._connected = false;
  }

  get connected() { return this._connected; }

  async connect() {
    if (this._logger) this._logger.event('machine_service_connect_attempt');
    // Online: there is no machine service. A kiosk host replaces this client.
    this._connected = false;
    return false;
  }

  async disconnect() {
    this._connected = false;
  }

  // eslint-disable-next-line class-methods-use-this
  creditIn() {
    throw new Error('MachineServiceClient.creditIn not implemented (online no-op stub)');
  }

  // eslint-disable-next-line class-methods-use-this
  creditOut() {
    throw new Error('MachineServiceClient.creditOut not implemented (online no-op stub)');
  }
}
